/**
 * @export
 * @class ContentsVideo
 * 딜 컨텐츠 비디오 영역
 */
export default class ContentsVideo {
  constructor() {
    this.checkComponentStatus();
  }

  clearEvent() {
    this.disableVideoMode();
  }

  /**
   * 비디오 여부에 따라 영역 초기화
   */
  checkComponentStatus() {
    if ($('#_wrapContentsVideo #youtube-wrapper').length > 0) {
      if (TMON.oApp.oUtil.isInternetExplorerUnder11()) {
        // IE11 미만인 경우 유튜브를 지원하지 않는다는 안내 메시지를 노출
        $('#_wrapContentsVideo #_youtubeDontSupportIE9').show();
      } else {
        this.enableVideoMode();
      }
    } else {
      this.disableVideoMode();
    }
  }

  /**
   * 비디오일 때 동작 처리
   *  - youtube 플레이어 스크립트 호출
   */
  enableVideoMode = () => {
    if (TMON.oApp.isLoadedYoutubePlayer) {
      this.onloadYoutubeApi();
    } else {
      this.loadYoutubeScript();
    }
  };

  /**
   * youtube 플레이어 스크립트 호출
   */
  loadYoutubeScript = () => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  /**
   * youtube 플레이어 스크립트 유무 확인
   * @param {*} url
   */
  checkScriptLoaded(url) {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src === url) return true;
    }
    return false;
  }

  /**
   * onloadYoutubeApi
   * YoutubeScript 가 onload 되었을 때
   */
  onloadYoutubeApi = () => {
    if (
      $('#_wrapContentsVideo #youtube-wrapper').length > 0 &&
      !TMON.oApp.oUtil.isInternetExplorerUnder11()
    ) {
      this.sYoutubeId = this.getYoutubeEmbededUrl();
      this.initPlayer();
    }
  };

  getYoutubeEmbededUrl = () => {
    let ID = '';
    let url =
      TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentInfo
        .contentsVideoUrl;
    url = url
      .replace(/(>|<)/gi, '')
      .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_/-]/i);
      ID = ID[0];
    } else {
      ID = url;
    }
    return ID;
  };

  initPlayer = () => {
    setTimeout(() => {
      this.onErrorCheck();
    }, 5000);
    this.oPlayer = new window.YT.Player('content-youtube-player', {
      height: '100%',
      width: '100%',
      videoId: this.sYoutubeId,
      playerVars: {
        showinfo: 0,
        playsinline: 1,
        fs: 0,
        rel: 0,
        controls: TMON.oApp.sPlatform === 'PW' ? 1 : 0,
        autoplay: 0,
        enablejsapi: 1,
        origin: location.origin,
      },
      events: {
        onReady: () => {
          this.onPlayerReady();
        },
        onStateChange: e => {
          this.onPlayerStateChange(e);
        },
        onError: () => {
          this.onPlayerError();
        },
      },
    });
    $('#_wrapContentsVideo #youtube-wrapper').on(
      'click',
      '[data-role=youtubePlayToggle]',
      () => {
        const nState = this.oPlayer.getPlayerState();
        /**
         * getPlayerState 는 youtube 공식 API 를 사용하고 있습니다.
         * 상태 반환에 대한 응답값은 아래 명세를 참고하세요.
         * https://developers.google.com/youtube/iframe_api_reference?hl=ko
         */
        if (nState === 1) {
          // 1은 재생중에 대한 값입니다.
          this.oPlayer.pauseVideo();
        } else {
          // 그 외의 값은 대부분 정지 중입니다. 재생 명령을 내려도 괜찮습니다.
          this.oPlayer.playVideo();
        }
      }
    );
  };

  onErrorCheck() {
    if (!this.bSuccessYoutube) {
      this.onPlayerError();
    }
  }

  onPlayerReady = () => {
    this.bSuccessYoutube = true;
    $('#_wrapContentsVideo #playerLoader').fadeOut('slow');
    $('#_wrapContentsVideo #youtube-wrapper').css({
      position: 'relative',
      height: `${TMON.oApp.sPlatform === 'PW' ? 433 : 300}px`,
    });
  };

  onPlayerStateChange = e => {
    if (e.data === 1) {
      // android 일부기종은 버튼이 있으면 재생이 안되고, ios(app, MW 모두)는 버튼이 없을 때 비디오영역 토글이 안됨
      // android 도 사용자 재생만 이뤄지면 이후 playVideo메서드가 동작하므로, 재생 후 버튼을 되살림 SDLUI-610, SDLUI-612
      $('#_wrapContentsVideo #_youtube_button').show();
      if (TMON.view_mode === 'app') {
        TMON.app.callApp(
          'webview',
          'setWebProperties',
          '{"isYoutubePlay":true}'
        );
      }
    } else if (e.data === 0 || e.data === 2) {
      if (TMON.view_mode === 'app') {
        TMON.app.callApp(
          'webview',
          'setWebProperties',
          '{"isYoutubePlay":false}'
        );
      }
    }
    // 반복재생
    if (e.data === 0) {
      this.oPlayer.playVideo();
    }
  };

  onPlayerError = () => {
    this.disableVideoMode();
  };

  disableVideoMode = () => {
    if (this.oPlayer) {
      this.oPlayer.destroy();
      delete this.oPlayer;
    }
    $('#_wrapContentsVideo .youtube-wrapper').hide();
  };
}
